import cn from 'classnames';
import styles from './BackgroundCard.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/** This card has a background color to offset it from the page, rather than a border like DetailCard */
export function BackgroundCard({ className, children }: Props) {
  return <section className={cn(styles.BackgroundCard, className)}>{children}</section>;
}
